import {
  postLogin,
  postRegister,
  verifyOTP,
  requestOTP
} from "./../../api/user/userService";

import Vue from "vue";
import router from "../../router";

const state = {
  auth_token: null,
  browser_token: null,
  user_data: null,
  is_new_user: false,
  is_fcr_user: false,
  phonenumber: null,
  transactionId: null,
  loanDetails: {}
};

const logoutState = state => {
  state.auth_token = null;
  state.phonenumber = null;
  state.user_data = null;
  // state.browser_token = null
  state.is_new_user = false;
  state.is_fcr_user = false;
  localStorage.removeItem("auth_token");
  localStorage.removeItem("phonenumber");
  localStorage.removeItem("user_data");
  // localStorage.removeItem('browser_token')
  localStorage.removeItem("is_fcr_user");
  localStorage.removeItem("is_new_user");
  localStorage.removeItem("transactionId");
};

const mutations = {
  SET_TOKEN(state, _data) {
    Vue.http.headers.common["Content-Type"] = "application/json";

    state.auth_token =
      _data.auth_token !== undefined ? _data.auth_token : state.auth_token;
    state.phonenumber =
      _data.phonenumber !== undefined ? _data.phonenumber : state.phonenumber;
    state.user_data =
      _data.user_data !== undefined ? _data.user_data : state.user_data;
    state.browser_token =
      _data.browser_token !== undefined
        ? _data.browser_token
        : state.browser_token;
    state.is_new_user =
      _data.is_new_user !== undefined ? _data.is_new_user : state.is_new_user;
    state.is_fcr_user =
      _data.is_fcr_user !== undefined ? _data.is_fcr_user : state.is_fcr_user;
    if (
      _data.auth_token !== undefined &&
      _data.auth_token !== null &&
      _data.auth_token !== ""
    ) {
      Vue.http.headers.common["Authorization"] = "Bearer " + _data.auth_token;
    }
    if (
      _data.browser_token !== undefined &&
      _data.browser_token !== null &&
      _data.browser_token !== ""
    ) {
      Vue.http.headers.common["x-browser-token"] = _data.browser_token;
    }
  },
  LOGOUT(state) {
    logoutState(state);
  },
  SET_TRANSACTION(state, _transactionId) {
    state.transactionId = _transactionId;
  },
  UPDATE_INFO(state, _data) {
    if (_data.user_data !== undefined) {
      state.user_data = {
        ...state.user_data,
        ..._data.user_data
      };
      localStorage.setItem("user_data", JSON.stringify(state.user_data));
    }
    if (_data.phonenumber !== undefined) {
      state.phonenumber = _data.phonenumber;
      localStorage.setItem("phonenumber", state.phonenumber);
    }
  },
  CHECK_WALLET(state, data) {
    let callback = data.callback ? data.callback : null;
    let allowCancel = data.allowCancel ? data.allowCancel : false;
    if (
      state.user_data.walletId == undefined ||
      state.user_data.walletId == null ||
      state.user_data.accountNumber == undefined ||
      state.user_data.accountNumber == null ||
      state.user_data.bankId == undefined ||
      state.user_data.bankId == null ||
      state.user_data.profilePictureUrl == undefined ||
      state.user_data.profilePictureUrl == null
    ) {
      Vue.swal({
        type: "warning",
        allowEscapeKey: allowCancel,
        showCancelButton: allowCancel,
        cancelButtonText: "Do this later",
        confirmButtonText: "Activate wallet now",
        allowOutsideClick: allowCancel,
        title: "",
        onClose: () => {
          if (callback !== null) {
            callback();
          }
        },
        html:
          "To begin enjoying our incredible services at lower rates, please upload your latest selfie and provide your account information to activate your wallet.<br>"
      }).then(result => {
        if (result.value) {
          router.push({
            name: "profile"
          });
        }
      });
    } else {
      if (callback !== null) {
        callback();
      }
    }
  },
  "CARBON_IDLE_WARN/IDLE_CHANGED"(state, data) {
    // scoped function
    function logoutReroute() {
      const _phoneNumber = state.phonenumber
      logoutState(state);
      router.push({
        name: "login",
        params: { idleRedirectPhoneNumber: _phoneNumber}
      });
    }

    // check if logged in and this is idle call
    if (state.auth_token && data === true) {
      // set timer to logout in the next 30 seconds
      const logoutTimerID = setTimeout(() => {
        logoutReroute();
      }, 30000);
      let timerInterval;

      Vue.swal({
        timer: 30000,
        imageUrl: "/images/svg/Error.svg",
        customClass: "format-title",
        title: `You will be logged out due to inactivity in <span id="span-text-timer">30</span> seconds. Please choose to stay signed in or log out. Otherwise, you would be logged out automatically.`,
        confirmButtonText: "Stay Signed In",
        showCancelButton: true,
        cancelButtonText: "Log out",
        onBeforeOpen: modElem => {
          timerInterval = setInterval(() => {
            modElem.querySelector("#span-text-timer").textContent = parseInt(
              Vue.swal.getTimerLeft() / 1000
            );
          }, 1000);
        },
        onClose: () => {
          clearInterval(timerInterval);
        }
      }).then(({ value, dismiss }) => {
        if (dismiss === 'cancel') {
           logoutReroute();
        }
          // YES STAY SIGNED IN
          clearTimeout(logoutTimerID);
      });
    }
  },
  UPDATE_LOAN_DETAILS(state, data) {
    state.loanDetails = data
  }
};

const actions = {
  initialiseStore({ commit }) {
    if (localStorage.getItem("auth_token")) {
      let userData = JSON.parse(localStorage.getItem("user_data"));
      // userData.walletId = null // TODO: for test remove it !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      commit("SET_TOKEN", {
        auth_token: localStorage.getItem("auth_token"),
        browser_token: localStorage.getItem("browser_token"),
        user_data: userData,
        phonenumber: localStorage.getItem("phonenumber"),
        is_new_user: localStorage.getItem("is_new_user"),
        is_fcr_user: localStorage.getItem("is_fcr_user")
      });
      commit(
        "SET_TRANSACTION",
        localStorage.getItem("transactionId") &&
          localStorage.getItem("transactionId") !== "null"
          ? localStorage.getItem("transactionId")
          : null
      );
    } else if (localStorage.getItem("browser_token")) {
      commit("SET_TOKEN", {
        browser_token: localStorage.getItem("browser_token")
      });
    }
  },

  saveToken({ commit }, data) {
    if (data.token !== undefined) {
      if (data.token == null) {
        localStorage.removeItem("auth_token");
      } else {
        localStorage.setItem("auth_token", data.token);
      }
    }

    if (data.browserAuthToken !== undefined) {
      if (data.browserAuthToken == null) {
        localStorage.removeItem("browser_token");
      } else {
        localStorage.setItem("browser_token", data.browserAuthToken);
      }
    }

    if (data.phonenumber !== undefined) {
      if (data.phonenumber == null) {
        localStorage.removeItem("phonenumber");
      } else {
        localStorage.setItem("phonenumber", data.phonenumber);
      }
    }
    if (data.user !== undefined) {
      if (data.user == null) {
        localStorage.removeItem("user_data");
      } else {
        localStorage.setItem("user_data", JSON.stringify(data.user));
      }
    }
    if (data.is_new_user !== undefined) {
      if (data.is_new_user == null) {
        localStorage.removeItem("is_new_user");
      } else {
        localStorage.setItem("is_new_user", data.is_new_user);
      }
    }
    if (data.is_fcr_user !== undefined) {
      if (data.is_fcr_user == null) {
        localStorage.removeItem("is_fcr_user");
      } else {
        localStorage.setItem("is_fcr_user", data.is_fcr_user);
      }
    }
    commit("SET_TOKEN", {
      auth_token: data.token,
      browser_token: data.browserAuthToken,
      user_data: data.user,
      phonenumber: data.phonenumber,
      is_new_user: data.is_new_user,
      is_fcr_user: data.is_fcr_user
    });
  },
  updateInfo({ commit }, data) {
    commit("UPDATE_INFO", data);
  },
  login({ commit }, data) {
    return postLogin(data.phone, data.password);
  },
  register({ commit }, data) {
    return postRegister(data);
  },
  logout({ commit }, data) {
    commit("LOGOUT");
  },
  requestOTP({ commit }, data) {
    return requestOTP();
  },

  verifyOTP({ commit }, data) {
    return verifyOTP(data.otp);
  },
  setTransaction({ commit }, _transactionId = null) {
    localStorage.setItem("transactionId", _transactionId);
    commit("SET_TRANSACTION", _transactionId);
  },
  checkWallet({ commit }, data) {
    commit("CHECK_WALLET", data);
  },
  sendEmail({ commit, state }) {
    const endpoint_url =
      "https://us-central1-carbon-overdraft.cloudfunctions.net/sendNotification";
    let query = `?name=${state.user_data.firstname} ${
      state.user_data.middlename
    } ${state.user_data.lastname}&clientId=${
      state.user_data.clientId
    }&phone_number=${state.user_data.phonenumber}`;

    return fetch(endpoint_url + query, {
      method: "POST",
      headers: new Headers({
        Accept: "*/*",
        "Cache-Control": "no-cache"
      })
    })
      .then(i => {
        return new Promise((resolve, reject) => {
          resolve(i);
        });
      })
      .catch(e => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
  }
};

export default {
  state,
  mutations,
  actions
};
